/* @flow */

import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Localizer from '../../../helpers/localization';
import Modal from '../modal';
import './KeyboardShortcutsModal.css';
import { PLAYER_SHORTCUT_LIST, type Shortcut, TRAILER_SHORTCUT_LIST, renderShortcutTrigger } from './helpers';

const KeyboardShortcutsModal = (): React.Node => {
  const features = useSelector((state) => state.appConfiguration.features);

  const renderShortcut = useCallback(
    (shortcut: Shortcut): React.Node => {
      const { action, feature, id, trigger } = shortcut;

      if (feature && !features[feature]) {
        return null;
      }

      return (
        <li key={id}>
          <div className='shortcut'>{renderShortcutTrigger(trigger)}</div>
          <div className='action'>{Localizer.localize(action)}</div>
        </li>
      );
    },
    [features],
  );

  const renderShortcutList = useCallback(
    (titleKey: string, list: Array<Shortcut>): React.Node => (
      <div className='column'>
        <div className='sectionTitle'>{Localizer.localize(titleKey)}</div>
        <ul role='presentation'>{list.map((shortcut) => renderShortcut(shortcut))}</ul>
      </div>
    ),
    [renderShortcut],
  );

  return (
    <Modal ariaLabel={Localizer.localize('accessibility.modal.keyboard_shortcuts')} className='keyboardShortcuts'>
      <div className='header'>{Localizer.localize('modal.keyboard_shortcuts.title')}</div>
      <div className='keyboardShortcutsContent'>
        {renderShortcutList('modal.keyboard_shortcuts.header.player', PLAYER_SHORTCUT_LIST)}
        {renderShortcutList('modal.keyboard_shortcuts.header.trailer', TRAILER_SHORTCUT_LIST)}
      </div>
    </Modal>
  );
};

export default KeyboardShortcutsModal;
